export default __webpack_public_path__ + "static/media/mid1.95d8cde8.jpg";